import { ComponentType } from 'react'
import { FaShareAlt } from 'react-icons/fa'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'

interface Props {
  subject: string
  body: string
  shareUrl: string
  beforeOnShareClick: () => Promise<void>
  hideLabel?: boolean
  iconSize?:number
  
}

const generateTcw = () => {
  return `${Math.floor(Math.random() * 1000000000000)}`
}

const getShareUrlWithSource = (shareUrl: string, source: string) => {
  const baseUrl = shareUrl.split('&c=')[0]
  return `${baseUrl}?c=${generateTcw()}${source}`
}
export const Share: ComponentType<Props> = ({ subject, body, shareUrl, hideLabel, iconSize, beforeOnShareClick }) => {

  return (
    <UncontrolledDropdown>
      <DropdownToggle color="link" className="p-0 font-weight-500">
        <FaShareAlt size={iconSize} /> {hideLabel ? '' : 'Compartir'}
      </DropdownToggle>
      <DropdownMenu className="p-0">
        <div className="d-flex px-10 py-20">
          <FacebookShareButton beforeOnClick={beforeOnShareClick} url={getShareUrlWithSource(shareUrl, 'fb')} quote={subject} className="mx-10">
            <FacebookIcon size={32} className="rounded-md" />
          </FacebookShareButton>
          <TwitterShareButton beforeOnClick={beforeOnShareClick} url={getShareUrlWithSource(shareUrl, 'tw')} title={subject} className="mx-10">
            <TwitterIcon size={32} className="rounded-md" />
          </TwitterShareButton>
          <WhatsappShareButton beforeOnClick={beforeOnShareClick} url={getShareUrlWithSource(shareUrl, 'wa')} title={subject} separator=":: " className="mx-10">
            <WhatsappIcon size={32} className="rounded-md" />
          </WhatsappShareButton>
          <LinkedinShareButton beforeOnClick={beforeOnShareClick} url={getShareUrlWithSource(shareUrl, 'in')} className="mx-10">
            <LinkedinIcon size={32} className="rounded-md" />
          </LinkedinShareButton>
          <EmailShareButton beforeOnClick={beforeOnShareClick} url={getShareUrlWithSource(shareUrl, 'email')} subject={subject} body={body} className="mx-10">
            <EmailIcon size={32} className="rounded-md" />
          </EmailShareButton>
        </div>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
